import React , {Component} from 'react';
import {checkPermission} from "../../utils/methods";
import {LandingFooterPanelV2, Layout, NavigationBarV2, RewardPageMain} from "../../components";
import PropTypes from "prop-types";

class RewardWebDesignContainer extends Component{
  render() {
    const { history } = this.props;
    const authToken = (checkPermission() && localStorage && localStorage.getItem('AUTH_TOKEN')) ? true : false;
    return (
      <Layout>
        <NavigationBarV2
          history={history}
          showInternalLinks={false}
          isUser={authToken}
        />
        <RewardPageMain  history={history}/>
        <LandingFooterPanelV2 isUser={authToken} />
      </Layout>
    );
  }
}

RewardWebDesignContainer.propTypes = {
  history: PropTypes.object
}

export default RewardWebDesignContainer;